class FormModal {
	constructor(el) {
		this.el = el
		this.open = false
		this.toggle = document.querySelectorAll('[href="#form"], [href="#application-form"]')
		this.close = this.el.querySelectorAll('.form-modal__close, .form-modal__overlay')

		this.toggle.forEach((button) => {

			if (button.classList.contains('modal-active')) return

			button.classList.add('modal-active')

			button.addEventListener('click', (e) => {
				e.preventDefault()

				document.querySelectorAll('.form-modal.open').forEach(modal => {
					modal.classList.remove('open')
				})
				 
				const targetModal = button.getAttribute('href')
				
				if (targetModal === '#form') {
					document.querySelector('[data-modal="form"]').classList.add('open')
				} else if (targetModal === '#application-form') {
					document.querySelector('[data-modal="application"]').classList.add('open')
				}
			})
		})

		this.close.forEach((button) => {
			button.addEventListener('click', () => {
				this.closeModal()
			})
		})
	}

	openModal() {
		this.open = true
		this.el.classList.add('open')
	}

	closeModal() {
		this.open = false
		this.el.classList.remove('open')
	}
}

export const initFormModal = () => {
	document.querySelectorAll('[data-modal]').forEach(el => {
		new FormModal(el)
	})
}

export default () => {}